import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import cn from 'classnames';
import Button from '../../atoms/Button/Button';
import styles from './ConfirmDeleteModal.module.css';

interface ConfirmDeleteModalProps {
  show: boolean;
  itemName?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = ({
  show,
  itemName,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal centered show={show} onHide={onCancel}>
      <div className={cn(styles.modal)}>
        <Modal.Body className={styles.modalBody}>
          {itemName ? (
            <>
              Are you sure you want to delete <strong>{itemName}</strong>?
            </>
          ) : (
            'Are you sure you want to delete this item?'
          )}
        </Modal.Body>
        <div className={styles.modalButtons}>
          <Button
            variant="danger"
            className={styles.button}
            onClick={onConfirm}
          >
            Delete
          </Button>
          <Button
            variant="light"
            className={styles.cancelButton}
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
